import client from '../client'

export const getBuyNowListingInfoKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/BuyNowListings/GetBuyNowListingInformation`

export async function getBuyNowListingInfo({ buyNowListingId }) {
  const params = new URLSearchParams({ buyNowListingId })

  return client(`${getBuyNowListingInfoKey}?${params}`)
}
